import React from 'react'
import { Card, CardContent, CardHeader, Divider, List, SvgIcon, Typography, Box, Skeleton } from '@mui/material'
import T from 'T'
import { Clock } from '@styled-icons/heroicons-outline/Clock'

const PaymentHistorySkeleton = () => (
  <Card elevation={0} variant="outlined" sx={{ width: '100%' }}>
    <CardHeader
      avatar={
        <SvgIcon>
          <Clock />
        </SvgIcon>
      }
      title={
        <Typography fontWeight={600} variant="h6">
          {T.PAYMENT_HISTORY}
        </Typography>
      }
    />
    <Divider />
    <CardContent sx={{ padding: 0 }}>
      <List disablePadding>
        <Box display="flex" alignItems="center" p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} flex={1}>
            <Skeleton width="40%" />
            <Skeleton width="30%" />
          </Box>
          <Box>
            <Skeleton width={80} />
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} flex={1}>
            <Skeleton width="40%" />
            <Skeleton width="30%" />
          </Box>
          <Box>
            <Skeleton width={80} />
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} flex={1}>
            <Skeleton width="40%" />
            <Skeleton width="30%" />
          </Box>
          <Box>
            <Skeleton width={80} />
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} flex={1}>
            <Skeleton width="40%" />
            <Skeleton width="30%" />
          </Box>
          <Box>
            <Skeleton width={80} />
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} flex={1}>
            <Skeleton width="40%" />
            <Skeleton width="30%" />
          </Box>
          <Box>
            <Skeleton width={80} />
          </Box>
        </Box>
      </List>
    </CardContent>
  </Card>
)

export default PaymentHistorySkeleton
